module.exports = __webpack_public_path__ + "img/high-heeled-shoe.e43513cb.png";